import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import MessageEditControls from './MessageEditControls';
import config from '../../../../../../../../config';
import Translate,{t} from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import './HardcodedMessages.css';

function ButtonMessageEdit({ value, updateMessage, type, user }) {
    const [editing, setEditing] = useState(false);

    const [currentValue, setCurrentValue] = useState('');

    const [buttonText, setButtonText] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [sdkButtonText, setSdkButtonText] = useState('');
    const [socialButtonText, setSocialButtonText] = useState('');

    const buttonInputRef = useRef(null);
    const singleInputRef = useRef(null);

    const typeMap = config.hardCodedMessagesTypesMap;

    const isCallToOperator = type === typeMap.callToOperator;
    const isRateButton = [typeMap.rateScore1Button,typeMap.rateScore2Button,typeMap.rateScore3Button,typeMap.rateScore4Button,typeMap.rateScore5Button].includes(type)

    const handleEditIconClick = () => {
        if (isCallToOperator) {
            const parts = value ? value.split('||') : [];
            const btn = parts.length > 0 ? parts[0] : '';
            const phone = parts.length > 1 ? parts[1].replace('tel:','') : '';
            setButtonText(btn);
            setPhoneNumber(phone);
            setEditing(true);

            setTimeout(() => buttonInputRef.current.focus(), 0);
        } else if (isRateButton) {
            const parts = value ? value.split('||') : [];
            setSdkButtonText(parts.length > 0 ? parts[0] : '');
            setSocialButtonText(parts.length > 1 ? parts[1] : '');
            setEditing(true);

            setTimeout(() => buttonInputRef.current.focus(), 0);
        } else {
            setCurrentValue(value || '');
            setEditing(true);
            setTimeout(() => singleInputRef.current.focus(), 0);
        }
    };

    const handleCancel = () => {
        setEditing(false);
        setCurrentValue('');
        setButtonText('');
        setPhoneNumber('');
        setSdkButtonText('');
        setSocialButtonText('');
    };

    const handleSave = async () => {
        if (isCallToOperator) {
            const combined = `${(buttonText.replace('||',' ') || '').trim()}||tel:${(phoneNumber || '').trim()}`;
            await updateMessage(combined);
        } else if (isRateButton) {
            const combined = `${(sdkButtonText.replace('||',' ') || '').trim()}||${(socialButtonText.replace('||',' ') || '').trim()}`;
            await updateMessage(combined);
        } else {
            await updateMessage(currentValue);
        }
        setEditing(false);
        setCurrentValue('');
        setButtonText('');
        setPhoneNumber('');
        setSdkButtonText('');
        setSocialButtonText('');
    };

    return (
        <div className="hcm-card hcm-card--button">

            <div className="hcm-card__body">
                {editing && isCallToOperator && (
                    <div className="hcm-inputs-row">
                        <Input
                            ref={buttonInputRef}
                            onChange={(e) => setButtonText(e.target.value)}
                            value={buttonText}
                            placeholder={user ? t({user,text:'buttonText'}) : 'Button text'}
                            maxLength={50}
                            style={{padding: '4px 10px', fontSize: '14px'}}
                        />
                        <Input
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            value={phoneNumber}
                            placeholder={user ? t({user,text:'phoneNumber'}) : 'Phone number'}
                            maxLength={30}
                            style={{padding: '4px 10px', fontSize: '14px'}}
                        />
                    </div>
                )}

                {editing && isRateButton && (
                    <div className="hcm-inputs-row">
                        <Input
                            ref={buttonInputRef}
                            onChange={(e) => setSdkButtonText(e.target.value)}
                            value={sdkButtonText}
                            placeholder={user ? t({user,text:'sdkButtonText'}) : 'SDK button text'}
                            maxLength={50}
                            style={{padding: '4px 10px', fontSize: '14px'}}
                        />
                        <Input
                            onChange={(e) => setSocialButtonText(e.target.value)}
                            value={socialButtonText}
                            placeholder={user ? t({user,text:'socialAppsButtonText'}) : 'Social apps button text'}
                            maxLength={50}
                            style={{padding: '4px 10px', fontSize: '14px'}}
                        />
                    </div>
                )}

                {editing && !isCallToOperator && !isRateButton && (
                    <input
                        ref={singleInputRef}
                        className="hcm-textarea"
                        onChange={(e) => setCurrentValue(e.target.value)}
                        value={currentValue}
                        maxLength="20"
                    />
                )}

                {!editing && (
                    isCallToOperator ? (
                        <div className="hcm-pair">
                            <span><span className="hcm-pair__key"><Translate text={'buttonText'}/>: </span>{(value || '').split('||')[0] || ''}</span>
                            <span><span className="hcm-pair__key"><Translate text={'phoneNumber'}/>: </span>{(value || '').split('||').length > 1 ? (value || '').split('||')[1].replace('tel:','') : ''}</span>
                        </div>
                    ) : isRateButton ? (
                        <div className="hcm-pair">
                            <span><span className="hcm-pair__key">{user ? t({user,text:'WEBCHAT'}) : 'SDK button text'}: </span>{(value || '').split('||')[0] || ''}</span>
                            <span><span className="hcm-pair__key">{user ? t({user,text:'integrations'}) : 'Social apps button text'}: </span>{(value || '').split('||').length > 1 ? (value || '').split('||')[1] : ''}</span>
                        </div>
                    ) : (
                        value
                    )
                )}
            </div>

            <MessageEditControls
                editing={editing}
                handleEditIconClick={handleEditIconClick}
                handleCancel={handleCancel}
                handleSave={handleSave}
            />
        </div>
    );
}

ButtonMessageEdit.propTypes = {
    value: PropTypes.string.isRequired,
    updateMessage: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

export default ButtonMessageEdit;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/ButtonMessageEdit.jsx